/* eslint-disable */
// (AUTO-GENERATED PAGE BUNDLE)
// PAGE NAME: comments-pinboard-teaser-page
// ==============================
import 'build/g1cBAFd4SVWIg2Asite/sass/core.scss'
import * as commandQueue from 'init/command-queue'
import globalStore from 'init/global-store'
import { checkTurntoflow } from 'email-flows/turntoflow-check'
import { loadConfig as loadGlobalConfig } from 'init/global.config'
import loadIcons from 'util/browser/load-icons'
import { loadMessages } from 'services/msg'
import * as commentsPinboardTeaserLoader from 'widgets/comments-pinboard-teaser/comments-pinboard-teaser-loader'
import tokenService from 'services/token-service'
import { hostsConfig, turnToConfig } from 'init/config'
import waitForValue from 'util/wait-for-value'

// This is already set in turnto.js (turnto-entry), but if this is a multi-build site due to
// multiple themes with varying sass var sets, then each page will have the webpack manifest code
// and therefore needs to have it set here as it won't know about the one in turnto.js
const path = process.env.NODE_ENV === 'development' || process.env.testProdBuild ? '' : 'v5/widgets/'
__webpack_public_path__ = `${hostsConfig.protocol}://${hostsConfig.widgetsHost}/${path}`

if (turnToConfig.sku) {
  globalStore.sku = turnToConfig.sku
}

function loadConfig(config) {
  loadIcons(config.svg)
  loadMessages(config.messages, config.pluralRuleFn)
  loadGlobalConfig(config.globalConfig)
  Promise.all([
    commentsPinboardTeaserLoader.loadWidget(config.commentsPinboardTeaser)
  ]).then(() => {
    globalStore.loaders = [
      commentsPinboardTeaserLoader
    ]
    commandQueue.init()
  })
  tokenService.loadLoggedInUser()
  checkTurntoflow()
}

if (process.env.forThemer) {
  // window.TurnTo defined in turnto.js
  window['TurnTo'].loadConfig = loadConfig
} else {
  waitForValue(() => window.TurnToPageConfig).then(() => {
    loadConfig(window.TurnToPageConfig)
  })
}
